import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item = _resolveComponent("item")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_app_link = _resolveComponent("app-link")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (!_ctx.item.hidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.hasOneShowingChild(_ctx.item.children, _ctx.item) && (!_ctx.onlyOneChild.children || _ctx.onlyOneChild.noShowingChildren) && !_ctx.item.alwaysShow)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.onlyOneChild.meta)
                ? (_openBlock(), _createBlock(_component_app_link, {
                    key: 0,
                    to: _ctx.resolvePath(_ctx.onlyOneChild.path, _ctx.onlyOneChild.query)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: _ctx.resolvePath(_ctx.onlyOneChild.path),
                        class: _normalizeClass({'submenu-title-noDropdown':!_ctx.isNest})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_item, {
                            icon: _ctx.onlyOneChild.meta.icon || (_ctx.item.meta && _ctx.item.meta.icon),
                            title: _ctx.onlyOneChild.meta.title
                          }, null, 8, ["icon", "title"])
                        ]),
                        _: 1
                      }, 8, ["index", "class"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              index: _ctx.resolvePath(_ctx.item.path),
              "popper-append-to-body": ""
            }, {
              title: _withCtx(() => [
                (_ctx.item.meta)
                  ? (_openBlock(), _createBlock(_component_item, {
                      key: 0,
                      icon: _ctx.item.meta && _ctx.item.meta.icon,
                      title: _ctx.item.meta.title
                    }, null, 8, ["icon", "title"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child, index) => {
                  return (_openBlock(), _createBlock(_component_sidebar_item, {
                    key: child.path + index,
                    "is-nest": true,
                    item: child,
                    "base-path": _ctx.resolvePath(child.path),
                    class: "nest-menu"
                  }, null, 8, ["item", "base-path"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["index"]))
      ]))
    : _createCommentVNode("", true)
}